import React from "react";
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/monmarche.png";
import { BsFillPlayCircleFill } from "react-icons/bs";

const About = () => {
  return (
    <div className="about-section-container">
      <div className="about-background-image-container">
        <img src={AboutBackground} alt="" />
      </div>
      <div className="about-section-image-container">
        <img src={AboutBackgroundImage} alt="" />
      </div>
      <div className="about-section-text-container">
        <p className="primary-subheading">Á propos</p>
        <h1 className="primary-heading">
        Livraison à domicile rapide et pratique
        </h1>
        <p className="primary-text">
        Fini les longues files d'attente et les déplacements fatigants au marché. 
        Nous livrons vos achats directement à votre porte, à l'heure qui vous convient.
        </p>
        <p className="primary-text">
        Notre équipe dévouée est toujours là pour répondre à vos questions, 
        traiter vos préoccupations et vous assurer une expérience d'achat agréable à chaque étape.
        </p>
        <div className="about-buttons-container">
          <button className="secondary-button">Voir plus</button>
          <button className="watch-video-button">
            <BsFillPlayCircleFill /> Regarder la Video
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
